import { Link } from "@tanstack/react-router";
import { Instagram, Facebook, MapPin, Phone, Mail } from "lucide-react";
import logoEmblem from "@/assets/logo-fleur.png.asset.json";
import logoTitle from "@/assets/logo-titre.png.asset.json";

export function Footer() {
  return (
    <footer style={{ backgroundColor: "#F0EBE4", color: "#6a6258", borderTop: "0.5px solid #e0d8d0" }}>
      <div className="mx-auto grid max-w-[1200px] gap-12 px-6 py-16 md:grid-cols-4">
        <div className="flex flex-col items-center text-center">
          <Link to="/" aria-label="Rénergescence — Accueil" className="flex flex-col items-center">
            <img src={logoEmblem.url} alt="" width={96} height={96} loading="lazy" decoding="async" className="h-20 w-20 object-contain md:h-24 md:w-24" />
            <img src={logoTitle.url} alt="Rénergescence" width={140} height={18} loading="lazy" decoding="async" className="mt-4 h-4 w-auto md:h-[18px]" />
          </Link>
          <p className="mt-2 text-[10px] uppercase tracking-[0.22em]" style={{ color: "#6a6258" }}>Santé naturelle &amp; bien-être</p>
          <div className="mt-5 flex gap-3">
            <a href="https://www.instagram.com/renergescence/" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><Instagram size={18} /></a>
            <a href="https://www.facebook.com/renergescence/" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><Facebook size={18} /></a>
          </div>
        </div>

        <div>
          <h2 className="text-xs uppercase tracking-[0.22em]" style={{ color: "#2D2B28" }}>Informations</h2>
          <ul className="mt-4 space-y-2 text-sm">
            {[
              { to: "/", label: "Accueil" },
              { to: "/a-propos", label: "À propos" },
              { to: "/prestations", label: "Prestations" },
              { to: "/prestations", hash: "bons-cadeaux", label: "Pour offrir" },
              { to: "/blog", label: "Blog" },
              { to: "/contact", label: "Contact" },
            ].map((l) => (
              <li key={l.label}>
                <Link to={l.to} hash={(l as { hash?: string }).hash} className="hover:opacity-70 transition-opacity">{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h2 className="text-xs uppercase tracking-[0.22em]" style={{ color: "#2D2B28" }}>Coordonnées</h2>
          <ul className="mt-4 space-y-3 text-sm">
            <li className="flex items-start gap-2">
              <MapPin size={16} className="mt-0.5 shrink-0" />
              <span><span className="font-medium" style={{ color: "#2D2B28" }}>Centre paramédical et de santé naturelle des fontaines</span><br />3 rue Ledru-Rollin<br />31300 Toulouse</span>
            </li>
            <li className="flex items-start gap-2">
              <MapPin size={16} className="mt-0.5 shrink-0" />
              <span><span className="font-medium" style={{ color: "#2D2B28" }}>Maison Hyggee</span><br />2643 route de Tarbes<br />31470 Fonsorbes</span>
            </li>
            <li className="flex items-center gap-2">
              <Phone size={16} />
              <a href="tel:+33689676546">06 89 67 65 46</a>
            </li>
            <li className="flex items-center gap-2">
              <Mail size={16} />
              <a href="mailto:contact@renergescence.com">contact@renergescence.com</a>
            </li>
          </ul>
        </div>

        <div>
          <h2 className="text-xs uppercase tracking-[0.22em]" style={{ color: "#2D2B28" }}>Infos légales</h2>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/deontologie" className="hover:opacity-70">Déontologie</Link></li>
            <li><Link to="/mentions-legales" className="hover:opacity-70">Mentions légales</Link></li>
            <li><Link to="/cgv" className="hover:opacity-70">CGV</Link></li>
          </ul>
        </div>
      </div>

      <div style={{ borderTop: "0.5px solid #e0d8d0" }}>
        <div className="mx-auto max-w-[1200px] px-6 py-6 text-center text-xs">
          © {new Date().getFullYear()} Rénergescence — Tous droits réservés
        </div>
      </div>
    </footer>
  );
}